import routes from './routes';
import VueRouter from 'vue-router';
import store from '@/store/index';

const router = new VueRouter({
  routes,
  mode: 'history'
});

const checkIfLoading = () => store.getters['loading/isLoading'];

router.beforeEach(async (to, from, next) => {
  // console.log('RE-ROUTE:', 'to:',to.name, 'from:',from.name, router.currentRoute)
  if(to && to.meta.requiresAuth === false && store.getters['loading/isFirstLoad']) {
    store.commit('routing/REQUIRES_AUTH_ON_LOAD', false)
  }

  const isAdmin = store.getters['current_user/isAreaAdmin']
  const isLoggedIn = store.getters['api/auth/isLoggedIn']
  // if guarded
  const ifRequiresAuth = to.meta.requiresAuth
  const ifRequiresAdmin = to.meta.requiresAdmin
  // const blockWhenAuthenticated = to.meta.blockWhenAuthenticated

  // if(!isLoggedIn && authNames.indexOf(to.name) === -1) {
  //   next('/login')
  // } else
  let ifLoading = await checkIfLoading()

  if(to.path === '/register') {
    window.location.replace(`${process.env.VUE_APP_SPACEIN_API_SSO_URL}/account/register`)
  } else if(ifLoading) {
    next()
  } else if (ifRequiresAuth) {
    if(ifRequiresAdmin && !isAdmin) {
      let areaId = to.params?.areaId
      if(areaId) {
        next(`/space/${areaId}`)
      } else {
        next('/404')
      }
    } else if (isLoggedIn) {
      next()
    } else {
      // Need to make sure we're not already going to root or we're just going to end up in an infinite loop
      if (to.path !== '/') {
        next('/')
      } else {
        next()
      }
    }
  } else {
    // if(isLoggedIn && blockWhenAuthenticated) {
    //   next('/')
    // } else {
    //   console.log('CONTINUE')
      next()
    // }
  }
});
router.afterEach(async (to,from) => {
  // console.log('RE-ROUTED:', 'to:',to.name, 'from:',from.name)
  store.commit('routing/CURRENT_ROUTE', to);

  if(to.name === 'signin' && from.name !== 'signin') {
    await store.dispatch('api/auth/signinCallback')
    return
  } else if(to.name === 'silent-refresh') {
    await store.dispatch('api/auth/silentRefreshCallback')
    return
  } else if(to.name === 'guest-signin') {
    await store.dispatch('api/auth/signinGuestCallback')
    return
  } else if(to.name === 'signout-callback') {
    await store.dispatch('api/auth/signoutCallback')
    return
  }
  if(!store.getters['loading/isFirstLoad']) store.dispatch('routing/changeHandler', [from,to]);
});

export default router;
